export function getInitials(fullName: string | null | undefined): string {
    const words = (fullName ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return '';
    }

    const firstChar = (word: string): string => Array.from(word)[0];
    const first = firstChar(words[0]);
    const last = words.length > 1 ? firstChar(words[words.length - 1]) : '';
    return (first + last).toUpperCase();
}
